import TravellerPage from '../../src/pages/TravellerPage';

export default TravellerPage;
